import { render, staticRenderFns } from "./domain_switcher.vue?vue&type=template&id=055704f8&scoped=true"
import script from "./domain_switcher.vue?vue&type=script&lang=js"
export * from "./domain_switcher.vue?vue&type=script&lang=js"
import style0 from "./domain_switcher.vue?vue&type=style&index=0&id=055704f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055704f8",
  null
  
)

export default component.exports